export default __webpack_public_path__ + "static/media/15.b8b7aca4.jpg";